module.exports = __webpack_public_path__ + "img/ic-lightning-black.747fed48.svg";